const landing_page = {
  aboutUs: "Tungkol sa Amin", // translated 
  topPackages: "Mga Nangungunang Pakete", // translated 
  featuredHotels: "Mga Itinatampok na Hotel", // translated 
  topTours: "Mga Nangungunang Paglilibot", // translated 
  whatOurMembersSay: "Ang sabi ng mga miyembro natin...", // translated 
  followUsOnInstagram: "Sundan kami sa Instagram", // translated 
  pleaseWait: "Mangyaring maghintay...", // translated 
  packages: "Mga Pakete", // translated 
  ourPartners: "Ang Aming mga Kasosyo", // translated 
  trustedCarHirePartners: "Mga Pinagkakatiwalaang Kasosyo sa Pag-upa ng Sasakyan", // translated 
  learnMore: "Matuto Nang Higit Pa", // translated 
};


export default landing_page;
